<template>
  <div v-if="show" class="modal">
    <div class="shadow">
      <span class="icon"></span>
      <p class="message">{{message}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["message"],
    ready(){
      this.StartTime();
    },
    data(){
      return {
        show: false,
        timer: null
      }
    },
    methods: {
      StartTime(){
        // console.log("到这里了");
        this.show = true;
        if (this.timer) {
          clearTimeOut(this.timer)
        } else {
          this.timer = setTimeout(() => {
            this.show = false;
          }, 300000);
        }
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .modal {
    position: fixed;
    left: 40%;
    top: 10px;
    z-index: 100000;
    align-items: center;
    text-align: center;

    .shadow{
      box-shadow: 0 3px 10px rgba(202, 195, 195, 0.5);

      .icon {
        background-color: orangered;
        width: 50px;
        height: 31px;
        position: absolute;
        left: 0px;
        top: 0px;
        border-radius: 2px 0px 0px 2px;
        border: 1px solid #f1f1f1;
      }

      .message {
        left: 50px;
        position: absolute;
        width: 150px;
        background-color: white;
        padding: 5px 60px 5px 10px;
        border-radius: 0px 2px 2px 0px;
        border: 1px solid #f1f1f1;
      }
    }

  }


</style>




// WEBPACK FOOTER //
// MessageBox.vue?f5de75a6